import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { MapComponent } from "./map/map.component";
import { GeolocationComponent } from "./geolocation/geolocation.component";

@NgModule({
    declarations: [    
      MapComponent,
      GeolocationComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
      CommonModule,
      SharedModule,
    ],
    exports: [
      MapComponent,
      GeolocationComponent
    ]
  })
  export class GisModule {}